/* Cashify Play - BookX booking UX helper (safe & additive). AVAILABILITY SPINNER only. While BookX fetches availability from bookeasy.logbase.io (which greys out Confirm on slow networks), show a 'Checking availability' spinner near Confirm so it reads as progress. It NEVER clicks or re-fires anything. The earlier force-open fallback was REMOVED because re-firing the tap could re-activate BookX mid-open and cause an add + redirect to cart without the date step. Real taps open BookX on their own. */
(function () {
  if (window.__cpgaBookingUX) return; window.__cpgaBookingUX = true;
  var WIDGET = '.bookeasy-widget-container-v2';
  var API = 'bookeasy.logbase.io';
  function widget() { return document.querySelector(WIDGET); }
  function isAvail(u) { try { return String(u).indexOf(API) > -1; } catch (e) { return false; } }
  function findConfirm() {
    var w = widget(); if (!w) return null;
    return Array.prototype.slice.call(w.querySelectorAll('button,a')).filter(function (b) { return (b.textContent || '').trim().toLowerCase() === 'confirm'; })[0] || null;
  }
  function ensureSpinStyle() {
    if (document.getElementById('cpga-spin-style')) return;
    var s = document.createElement('style'); s.id = 'cpga-spin-style';
    s.textContent = '@keyframes cpgaSpin{to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }
  function note(show) {
    var w = widget(); if (!w) return;
    var n = document.getElementById('cpga-avail-note');
    if (!n && show) {
      ensureSpinStyle();
      n = document.createElement('div');
      n.id = 'cpga-avail-note';
      n.style.cssText = 'display:flex;align-items:center;gap:8px;justify-content:center;padding:8px 12px;font-size:13px;color:#5b5b5b;';
      n.innerHTML = '<span style="width:14px;height:14px;border:2px solid #cbb8ff;border-top-color:#7b5cff;border-radius:50%;display:inline-block;animation:cpgaSpin .7s linear infinite;"></span> Checking availability&hellip;';
      var c = findConfirm();
      if (c && c.parentNode) { c.parentNode.insertBefore(n, c); } else { w.appendChild(n); }
    }
    if (n) n.style.display = show ? 'flex' : 'none';
  }
  var inflight = 0;
  function inc() { inflight++; note(true); }
  function dec() { inflight = Math.max(0, inflight - 1); if (inflight === 0) note(false); }
  var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cpgaAvail = isAvail(u); return oOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () { if (this.__cpgaAvail) { inc(); this.addEventListener('loadend', dec); } return oSend.apply(this, arguments); };
  var oFetch = window.fetch;
  window.fetch = function (u) { var a = isAvail((typeof u === 'string') ? u : (u && u.url)); var p = oFetch.apply(this, arguments); if (a) { inc(); p.then(dec, dec); } return p; };
})();
